/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-02-16",
    versionChannel: "nightly",
    buildDate: "2024-02-16T00:16:18.720Z",
    commitHash: "4bcba369570532471e8da2b9c9b6c894e991e914",
};
